/** callerの中断と時間上限を合成し、body読込・非対応の待機も期限内に終了させる。 */
export async function withRequestDeadline<T>(
  run: (signal: AbortSignal) => Promise<T>,
  signal?: AbortSignal,
  timeoutMs = 20_000,
): Promise<T> {
  const controller = new AbortController();
  const timer = setTimeout(
    () =>
      controller.abort(
        new DOMException(
          "通信がタイムアウトしました。結果を確認して再試行してください",
          "TimeoutError",
        ),
      ),
    timeoutMs,
  );
  const combined = signal
    ? AbortSignal.any([signal, controller.signal])
    : controller.signal;
  let abort: (() => void) | undefined;
  try {
    combined.throwIfAborted();
    return await Promise.race([
      run(combined),
      new Promise<never>((_resolve, reject) => {
        abort = () => reject(combined.reason);
        combined.addEventListener("abort", abort, { once: true });
        if (combined.aborted) abort();
      }),
    ]);
  } finally {
    clearTimeout(timer);
    if (abort) combined.removeEventListener("abort", abort);
  }
}
